<div
  class="ag-cell-label-container"
  (mouseup)="onMouseUp($event)"
  (touchstart)="onTouchStart()"
  (touchend)="onTouchEnd($event)"
>
  <span class="header-cell-name">{{ title }}</span>
  <span
    class="ag-header-icon ag-sort-ascending-icon"
    [ngClass]="{ 'ag-hidden': !isActive || sortOrder !== 'asc' }"
  >
    <span class="ag-icon ag-icon-asc"></span>
  </span>
  <span
    class="ag-header-icon ag-sort-descending-icon"
    [ngClass]="{ 'ag-hidden': !isActive || sortOrder !== 'desc' }"
  >
    <span class="ag-icon ag-icon-desc"></span>
  </span>
  <span
    class="ag-header-icon ag-sort-descending-icon"
    [ngClass]="{ 'ag-hidden': !isActive || !!sortOrder }"
  >
    <span class="ag-icon ag-icon-desc"></span>
  </span>
</div>
